import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdatePackageUnitForm from '../../forms/CreateOrUpdatePackageUnitForm'

interface CreatePackageUnitModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreatePackageUnitModal: React.FC<CreatePackageUnitModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => (
  <AppModal open={open} onClose={onClose} title="Add Package Unit" width="sm" loading={loading}>
    <CreateOrUpdatePackageUnitForm loading={loading} error={error} />
  </AppModal>
)

export default CreatePackageUnitModal
